<template>
    <el-dialog title="回收客户" :visible.sync="customerRecoveryVisible" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false"
        custom-class="custom-form-dialog custom-allocation-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="formLoading">
            <el-form-item label="回收至" prop="sea_id">
                <el-select placeholder="请选择公海" v-model="formData.sea_id" filterable>
                    <el-option v-for="seaItem in highSeasList" :key="seaItem.id" :value="seaItem.id" :label="seaItem.seas_name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <template #label>
                    <span class="bold-text">下列客户可被回收</span>
                </template>
                <div class="select-company">
                    <p v-for="(companyItem,companyIndex) in selectedList" :key="companyItem.id">{{selectedList.length > 1 ? (companyIndex + 1) + "." : ''}}{{ companyItem.name && companyItem.name.value }}</p>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {CustomerPrivateRecycle, GetHighSeasManagementList} from "@/api"
export default {
    name: "CustomerRecovery",
    props: {
        customerRecoveryVisible: {
            type: Boolean,
            default: false
        },
        selectedList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            dialogVisible: false,
            formLoading: true,
            formData: {
                sea_id: ""
            },
            formRules: {
                sea_id: [
                    { required: true, message: "请选择公海", trigger: "change" }
                ]
            },
            highSeasList: [],
            btnDisabled: false
        }
    },
    mounted() {
        this.getHighSeasManagementList()
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:customerRecoveryVisible", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.btnDisabled = true
                    this.formLoading = true
                    const params = {
                        sea_id: this.formData.sea_id,
                        customer_ids: this.selectedList.map(item=> item.id)
                    }
                    CustomerPrivateRecycle(params).then(res=> {
                        if(res.code === 200) {
                            this.$message.success(res.message)
                            this.$emit("update:customerRecoveryVisible", false)
                            this.$emit("updateCallback")
                        }
                        this.btnDisabled = false
                        this.formLoading = false
                    }).catch(()=> {
                        this.btnDisabled = false
                        this.formLoading = false
                    })
                }
            })
        },
        getHighSeasManagementList(name) {
            GetHighSeasManagementList({}).then(res=> {
                if(res.code === 200) {
                    this.highSeasList = res.data || []
                }
                this.formLoading = false
            }).catch(()=> {
                this.formLoading = false
            })
        }
    }
}
</script>
<style lang="scss">
.custom-allocation-dialog {
    .el-form {
        .el-form-item__content {
            height: auto;
        }
    }
    .bold-text {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .select-company {
        margin-top: 4px;
        padding: 8px 12px;
        border-radius: 6px;
        background: rgba(247, 248, 250, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        max-height: 236px;
        overflow-y: scroll;
    }
}
</style>
